import { Pipe, PipeTransform } from '@angular/core';
import {
  SafeHtml,
  SafeResourceUrl,
  SafeScript,
  SafeStyle,
  SafeUrl,
} from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SafePipe } from './safe.pipe';

@Pipe({ name: 'safeAsync' })
export class SafeAsyncPipe implements PipeTransform {
  constructor(private safePipe: SafePipe) {}

  transform(
    value: Observable<string>,
    type: string
  ): Observable<SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl> {
    return value.pipe(map(v => this.safePipe.transform(v, type)));
  }
}
